/** @format */

import * as types from './taxchatServiceInitiationTypes';

const initialState = {
  serviceInitiationRequests: {
    serviceRequests: [],
    total: 0,
    columns: [],
  },
  selectedRequest: {},
  filters: {
    pageNumber: 1,
    pageSize: 25,
    sortDirection: 'desc',
    sortColumn: 'RequestDate',
    searchText: null,
    requestDate: undefined,
    eyActionId: null,
    filter:true,
  },
  isDetailLoading: false,
  isUpdating: false,
  error: null,
  success: false,
  populatePayload: false,
  serviceInitFilters:{
    filter: undefined,
    eyActionId: undefined,
    eyActionIndex: undefined,
    requestDate: undefined,
  }
};

const taxchatServiceInitiationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SERVICE_INITIATION_FILTERS_SUCCESS:
      return {
        ...state,
        filters: action.payload,
      };

    // Get service initiation requests
    case types.GET_SERVICE_INITIATION_REQUESTS_SUCCESS:
      return {
        ...state,
        serviceInitiationRequests: action.payload,
        error: null,
        success: true,
      };
    case types.GET_SERVICE_INITIATION_REQUESTS_FAILURE:
      return {
        ...state,
        error: action.error,
        success: false,
      };

    // Get service initiation detail
    case types.GET_SERVICE_INITIATION_DETAIL_PENDING:
      return {
        ...state,
        isDetailLoading: true,
        error: null,
      };
    case types.GET_SERVICE_INITIATION_DETAIL_SUCCESS:
      return {
        ...state,
        selectedRequest: action.payload,
        isDetailLoading: false,
        error: null,
        success: true,
      };
    case types.GET_SERVICE_INITIATION_DETAIL_FAILURE:
      return {
        ...state,
        isDetailLoading: false,
        error: action.error,
        success: false,
      };

    // Update EY Action
    case types.UPDATE_SERVICE_INITIATION_ACTION_PENDING:
      return {
        ...state,
        isUpdating: true,
        error: null,
      };
    case types.UPDATE_SERVICE_INITIATION_ACTION_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        error: null,
        success: true,
      };
    case types.UPDATE_SERVICE_INITIATION_ACTION_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.error,
        success: false,
      };

    // Reset selected service request
    case types.RESET_SERVICE_INITIATION_DETAIL:
      return {
        ...state,
        isDetailLoading:false,
        isUpdating:false,
        error:null,
        success:false,
        selectedRequest: {},
      };

    // Set filters
    case types.SET_SERVICE_INITIATION_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };
    case types.CLEAR_SERVICE_INITIATION_FILTERS:
      return { ...state, serviceInitFilters: initialState.serviceInitFilters };

    case types.ON_CHANGE_SERVICE_INITIATION_FILTER:
      return {
        ...state,
        serviceInitFilters: {
          ...state.serviceInitFilters,
          ...action.payload,
        },
      };
    case types.SET_SERVICE_INITIATION_PARAMS_SUCCESS: {
        return { ...state, servicePayload: action.payload };
    }

    case types.SET_SERVICE_INITIATION_POPULATE_PAYLOAD_SUCCESS: {
        return { ...state, populatePayload: action.flag };
    }
    default:
      return state;
  }
};

export { initialState };
export default taxchatServiceInitiationReducer;
